function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("circle", {
  cx: 44,
  cy: 52,
  r: 44,
  fill: "#FA6358",
  fillOpacity: 0.15
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M35.84 50.273c.69 0 1.79-.052 3.3-.156 1.615-.104 2.898-.156 3.848-.156 3.32 0 5.88.788 7.676 2.363 1.797 1.563 2.695 3.985 2.695 7.266 0 2.161-.436 4.004-1.308 5.527-.86 1.524-2.142 2.689-3.848 3.496-1.693.795-3.763 1.192-6.21 1.192-1.082 0-2.117-.026-3.106-.078l-.742-.02V80h-4.356V50.273h2.05zm5.898 16.329c1.433 0 2.676-.19 3.73-.567 1.068-.377 1.928-1.08 2.579-2.11.65-1.028.976-2.46.976-4.296 0-2.253-.573-3.906-1.718-4.961-1.133-1.055-2.832-1.582-5.098-1.582-1.719 0-3.073.124-4.063.371v12.95c.964.13 2.162.195 3.594.195zm18.376-16.329c.742 0 1.764-.045 3.067-.136.182-.013.696-.046 1.543-.098.859-.052 1.666-.078 2.421-.078 4.7 0 8.223 1.237 10.567 3.71 2.356 2.475 3.535 6.017 3.535 10.626 0 3.307-.573 6.165-1.719 8.574-1.146 2.396-2.786 4.238-4.922 5.527-2.135 1.276-4.655 1.915-7.558 1.915-.6 0-1.745-.053-3.438-.157-1.875-.104-3.216-.156-4.023-.156h-1.66V50.273h2.187zM67.36 77.09c2.89-.065 5.17-1.08 6.836-3.047 1.68-1.98 2.52-5.013 2.52-9.102 0-2.89-.391-5.201-1.172-6.933-.781-1.732-1.947-2.982-3.496-3.75-1.55-.768-3.522-1.153-5.918-1.153-1.537 0-2.813.105-3.828.313v23.3c.612.144 1.373.248 2.285.313.924.052 1.849.072 2.773.059zm35.72-26.817v3.36H90.385v9.746h9.511v3.36h-9.511V80h-4.376V50.273h17.071z",
  fill: "#444"
});

function SvgPdfinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 104 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2);
}

export default SvgPdfinline;